<script setup lang="ts">
import ZikrSection from "@/components/zikr/ZikrSection.vue";
</script>

<template>
  <ZikrSection />
</template>
